import React from 'react';

class ResizeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Only update state if the error is ResizeObserver related
    if (error.toString().includes('ResizeObserver')) {
      return { hasError: false }; // Return false to prevent error UI
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore ResizeObserver errors, but log other errors
    if (!error.toString().includes('ResizeObserver')) {
      console.error('Error:', error);
      console.error('Error Info:', errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback || null;
    }

    return this.props.children;
  }
}

export default ResizeErrorBoundary;
